import React from 'react';
import './Inbox.scss';
import InboxMenu from './InboxMenu';
import { checkUserPermission } from '../../helpers/validationHelper';
import { useSelector } from 'react-redux';
import { USER_ROLES } from '../../common/constants';

const InboxHeader = ({
  type,
  onSelectType
}) => {
  const messageType = type === "Messages" ? "active" : "";
  const announcementType = type === "Announcements" ? "active" : "";
  const permission = useSelector(state => state.tabSelections)
  const { allowedTabList } = permission
  let showAnnouncementsForHomeowner = allowedTabList.filter((permission) => permission.name === "Announcements")[0];
  const showAnnouncement = checkUserPermission("Announcements");
  const user = useSelector(state => state.auth?.user || {})
  const roleName = user.roles[0].role.name;

  const showGeneral = !(roleName === USER_ROLES.SERVICE_PROVIDER || roleName === USER_ROLES.SERVICE_MANAGER);
  
  return (
    <div className='messaagesBtns'>
      <ul>
        <li style={{ cursor: 'pointer' }}>
          <a className={messageType} onClick={() => onSelectType('Messages')}>Messages</a>
        </li>
        {(showAnnouncement || showAnnouncementsForHomeowner !== undefined) &&
          <li style={{ cursor: 'pointer' }}>
            <a className={announcementType} onClick={() => onSelectType('Announcements')}>Announcements</a>
          </li>
        }
        <li style={{ cursor: 'pointer' }}>
          <InboxMenu 
            onSelectType={onSelectType}
            type={type}
            showGeneral={showGeneral}
          />
        </li>
      </ul>
    </div>
  )
}

export default InboxHeader;